import { Form, Popup } from 'devextreme-react';
import {
  ButtonItem,
  ButtonOptions,
  GroupItem,
  Label,
  RequiredRule,
  SimpleItem,
} from 'devextreme-react/form';
import React, { useEffect, useRef, useState } from 'react';
import '../../assets/bulk-modal.scss';
import { useTranslation } from '../../contexts/translation';
import { dxSelectBoxConfig } from '../../forms/workSheets/WorkSheetsForm';
import { Asset } from '../../types/asset.types';
import { CapacityCategory } from '../../types/capacityCategory.types';
import { DataGridActionType } from '../../types/dataGridActionTypes';
import { DocumentType } from '../../types/documentType.types';
import './TasksBulkEditModal.scss';

type Props = {
  data: any;
  isVisible: boolean;
  mutate?: () => void;
  onClose: () => void;
  onSubmit: (data: any, actionType: DataGridActionType) => void;
  actionType: DataGridActionType;
  capacityCategories: CapacityCategory[];
  documentTypes: DocumentType[];
  assets: Asset[];
};

/**
 * Modalová komponent pro vytváření/editaci záznamů typu Work Activity v datagridu
 */
export default function TaskAssistancePanelModal({
  isVisible,
  onClose,
  data,
  actionType,
  onSubmit,
  capacityCategories,
  documentTypes,
  assets,
}: Props) {
  const { translate } = useTranslation();
  const transFormName = 'TaskAssistancePanel.Form';
  const formRef = useRef<Form>(null);

  const [formData, setFormData] = useState<any>({});

  useEffect(() => {
    setFormData({ ...data, ...(actionType === DataGridActionType.Insert && { visible: true }) });
  }, []);

  return (
    <Popup
      visible={isVisible}
      dragEnabled={false}
      closeOnOutsideClick
      onHiding={onClose}
      showTitle
      title={translate!('Task assistance panel', transFormName)}
      width={'auto'}
      height={'auto'}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(formData, actionType);
        }}
      >
        <Form
          formData={formData}
          showColonAfterLabel={true}
          showValidationSummary={true}
          ref={formRef}
        >
          <GroupItem>
            <SimpleItem
              dataField={'assetId'}
              editorType={'dxSelectBox'}
              editorOptions={{
                ...dxSelectBoxConfig,
                valueExpr: 'id',
                displayExpr: 'name',
                dataSource: assets,

                // onValueChanged: handleAssetChanged,
              }}
              isRequired={true}
            >
              <Label text={translate!('Asset', transFormName)} />
              <RequiredRule message={translate!('Asset is required', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem>
            <SimpleItem dataField="name" editorType="dxTextBox">
              <Label text={translate!('Name', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem>
            <SimpleItem dataField="position" editorType="dxNumberBox">
              <Label text={translate!('Position', transFormName)} />
              <RequiredRule message={translate!('Position is required', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <SimpleItem
            dataField="capacityCategoryId"
            editorType="dxSelectBox"
            editorOptions={{
              items: capacityCategories,
              valueExpr: 'id',
              displayExpr: 'name',
            }}
            isRequired={true}
          >
            <Label text={translate!('Capacity category', transFormName)} />
          </SimpleItem>
          <GroupItem visible={documentTypes !== undefined}>
            <SimpleItem
              dataField="documentTypeId"
              editorType="dxSelectBox"
              editorOptions={{
                items: documentTypes,
                valueExpr: 'id',
                displayExpr: 'nameTranslated',
              }}
              isRequired={true}
            >
              <Label text={translate!('Document type', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem>
            <SimpleItem dataField="visible" editorType="dxCheckBox">
              <Label text={translate!('Visible', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem colCount={4}>
            <GroupItem colSpan={2}></GroupItem>
            <ButtonItem>
              <ButtonOptions
                width={'100%'}
                type={'normal'}
                text={translate!('Save', '')}
                useSubmitBehavior
              />
            </ButtonItem>
            <ButtonItem>
              <ButtonOptions
                width={'100%'}
                type={'normal'}
                text={translate!('Close', '')}
                onClick={onClose}
              />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </Popup>
  );
}
